__turbopack_context__.v({
  "breaking": "LiveblogUpdate-module-scss-module__Zj0U2W__breaking",
  "imageFigure": "LiveblogUpdate-module-scss-module__Zj0U2W__imageFigure",
  "update": "LiveblogUpdate-module-scss-module__Zj0U2W__update",
  "updateBody": "LiveblogUpdate-module-scss-module__Zj0U2W__updateBody",
  "updateDate": "LiveblogUpdate-module-scss-module__Zj0U2W__updateDate",
  "updateHeader": "LiveblogUpdate-module-scss-module__Zj0U2W__updateHeader",
  "updateHeaderActions": "LiveblogUpdate-module-scss-module__Zj0U2W__updateHeaderActions",
  "updateHeaderContent": "LiveblogUpdate-module-scss-module__Zj0U2W__updateHeaderContent",
  "updateHeadline": "LiveblogUpdate-module-scss-module__Zj0U2W__updateHeadline",
});
